<template>
    <div class="task-wrapper v3">
        <div class="task-list">
            <task-item
                v-for="(item,index) in taskInfoList"
                :key="index"
                :task-data="item"
            />
        </div>
        <div v-if="isShowLackCoinsToast" class="toast-mask">
            <div class="lack-coins-toast">
                <div class="know-btn" @click="closeToast"></div>
            </div>
            <div class="closed-btn" @click="closeToast"></div>
        </div>
    </div>
</template>

<script>
import TaskItem from './TaskItem.vue';

export default {
    data() {
        return {
            isShowLackCoinsToast: false,
            taskInfoList: this.taskInfo
        };
    },
    props: {
        taskInfo: {
            type: Array,
            default: () => ([])
        }
    },
    watch: {
        taskInfo(newVal) {
            this.taskInfoList = newVal;
        }
    },
    components: {
        TaskItem
    },
    computed: {
    },
    methods: {
        hiddenToast() {
            this.isShowLackCoinsToast = false;
        },
        closeToast() {
            if (this.isShowLackCoinsToast) {
                this.isShowLackCoinsToast = false;
            }
        }
    }
};
</script>
<style lang='scss' scoped>
.task-wrapper {
    width: 100%;
    height: 400px;
    margin-top: 13px;

    .toast-mask {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, .8);
        z-index: 100;
        display: flex;
        flex-direction: column;
        align-items: center;

        .lack-coins-toast {
            width: 289px;
            height: 210px;
            margin-top: 202px;
            background: url('../../../assets/v2/welfare/lackcoin-toast.png');
            background-size: cover;
            display: flex;
            justify-content: center;

            .know-btn {
                width: 184px;
                height: 41px;
                margin-top: 132px;
            }
        }

        .closed-btn {
            width: 28px;
            height: 28px;
            margin-top: 21px;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            background-image: url('../../../assets/v2/welfare/close-toast-btn.png');
        }
    }
    &.v3 {
        height: auto;
        padding-bottom: 20px;
        .task-list {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
        }
    }
}
</style>